<template>
  <v-app>
    <v-navigation-drawer app dark temporary v-model="drawer">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="text-h6"> EK Companion </v-list-item-title>
          <v-list-item-subtitle>{{ version }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list nav dense>
        <v-list-item-group v-model="group" active-class="text--accent-4">
          <v-list-item to="map">
            <v-list-item-icon>
              <v-icon>mdi-map</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Map</v-list-item-title></v-list-item
          >
          <v-list-item to="areas">
            <v-list-item-icon>
              <v-icon>mdi-map-marker</v-icon>
            </v-list-item-icon>
            <v-list-item-title
              ><v-badge :content="areasBadge" inline
                >Areas</v-badge
              ></v-list-item-title
            >
          </v-list-item>

          <v-list-item to="quests">
            <v-list-item-icon>
              <v-icon>mdi-book-open-page-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-title
              ><v-badge :content="questsBadge" inline
                >Quests</v-badge
              ></v-list-item-title
            >
          </v-list-item>

          <v-list-item to="bosses">
            <v-list-item-icon>
              <v-icon>mdi-fencing</v-icon>
            </v-list-item-icon>
            <v-list-item-title
              ><v-badge :content="bossesBadge" inline
                >Bosses</v-badge
              ></v-list-item-title
            >
          </v-list-item>

          <v-list-item to="secrets">
            <v-list-item-icon>
              <v-icon>mdi-floor-plan</v-icon>
            </v-list-item-icon>
            <v-list-item-title
              ><v-badge :content="secretsBadge" inline
                >Secrets</v-badge
              ></v-list-item-title
            >
          </v-list-item>

          <v-list-item to="tomes">
            <v-list-item-icon>
              <v-icon>mdi-book</v-icon>
            </v-list-item-icon>
            <v-list-item-title
              ><v-badge :content="secretsBadge" inline
                >Tomes</v-badge
              ></v-list-item-title
            >
          </v-list-item>

          <v-list-item to="achievements">
            <v-list-item-icon>
              <v-icon>mdi-trophy</v-icon>
            </v-list-item-icon>
            <v-list-item-title
              ><v-badge :content="achievementsBadge" inline
                >Achievements</v-badge
              ></v-list-item-title
            >
          </v-list-item>
          <v-list-item to="stats">
            <v-list-item-icon>
              <v-icon>mdi-chart-bar</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Stats'"></v-list-item-title>
          </v-list-item>
          <v-list-item to="weapons">
            <v-list-item-icon>
              <v-icon>mdi-sword-cross</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Weapons'"></v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="primary">
      <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
      <v-app-bar-title
        v-text="$route.name"
        class="text-capitalize"
      ></v-app-bar-title>
      <v-spacer></v-spacer>
      <Configuration></Configuration>
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>


<script>
import { mapGetters } from "vuex";

import { version } from "../package";

import Configuration from "./components/Configuration"



export default {
  name: "App",
  components: { Configuration },
  data: () => ({
    version: version,
    drawer: false,
    group: null,
  }),
  created() {
    this.$store.dispatch("entities/grids/load");
    this.$store.dispatch("entities/areas/load");
    this.$store.dispatch("entities/quests/load");
    this.$store.dispatch("entities/bosses/load");
    this.$store.dispatch("entities/secrets/load");
    this.$store.dispatch("entities/tomes/load");
    this.$store.dispatch("entities/achievements/load");
    this.$store.dispatch("entities/weapons/load");
  },
  computed: {
    ...mapGetters("entities/areas", { statsAreas : "stats" }),
    ...mapGetters("entities/quests", { statsQuests : "stats" }),
    ...mapGetters("entities/bosses", { statsBosses : "stats" }),
    ...mapGetters("entities/secrets", { statsSecrets : "stats" }),
    ...mapGetters("entities/tomes", { statsTomes : "stats" }),
    ...mapGetters("entities/achievements", {statsAchievements: "stats"}),

    areasBadge: function () {
      return this.statsAreas.progress + "%";
    },
    questsBadge: function () {
      return this.statsQuests.progress + "%";
    },
    bossesBadge: function () {
      return this.statsBosses.progress + "%";
    },
    secretsBadge: function () {
      return this.statsSecrets.progress + "%";
    },
    tomesBadge: function () {
      return this.tomesBadge.progress + "%";
    },
    achievementsBadge: function () {
      return this.statsAchievements.progress + "%";
    },

  },
};
</script>

<style scoped>
.v-list-item__title > .v-badge {
  margin-top: 0px !important;
}
</style>
